"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorInfo = exports.catchTCOLError = void 0;
const catchTCOLError = ({ response }) => {
    let errorCode = '';
    let errorDetails = '';
    try {
        errorCode = response.data.error.codigoErrorNegocio;
        errorDetails = response.data.error.descripcionErrorNegocio;
    }
    catch (err) {
        // FAILED TO CATCH TCOL ERROR
    }
    return { errorCode, errorDetails };
};
exports.catchTCOLError = catchTCOLError;
const getErrorInfo = (error) => {
    let errorCode = '';
    let errorDetails = '';
    if (error) {
        ({ errorCode, errorDetails } = (0, exports.catchTCOLError)(error));
        if (!errorCode && !errorDetails) {
            errorCode = error.status;
            errorDetails = error.response;
        }
    }
    else {
        errorCode = '500';
        errorDetails = 'Error en el servidor';
    }
    return { errorCode, errorDetails };
};
exports.getErrorInfo = getErrorInfo;
//# sourceMappingURL=tools.js.map